import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-da740426")

_pushScopeId("data-v-da740426")
const _hoisted_1 = { class: "swipe__wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      ref: "handle",
      class: "d-f swipe",
      style: {transform: `translate3d(${_ctx.offset}px, 0, 0)`}
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: ["flex-1 swipe__item", _ctx.itemClass],
          style: {left: index * 100 + '%'}
        }, [
          _renderSlot(_ctx.$slots, "default", { item: item }, undefined, true)
        ], 6))
      }), 128))
    ], 4),
    (_ctx.dot)
      ? (_openBlock(), _createBlock("ul", {
          key: 0,
          class: ["indicator", {'t-right': _ctx.dotPosition==='right', 't-left': _ctx.dotPosition==='left', 't-center': !_ctx.dotPosition}]
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list.length, (i) => {
            return (_openBlock(), _createBlock("li", {
              key: i,
              class: ['dot', {active: i - 1 === _ctx.index, 'dot-dark': _ctx.dotDark}]
            }, null, 2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
})